export const COMMUNITY_PAGES_PATH_PREFIX = "/c"

export enum CUSTOM_COMMUNITY_BUTTONS {
  SAVE_OUR_SOUND = "SAVE_OUR_SOUND",
}

export type CommunityData = {
  code: string
  inviteCode?: string
  waitlist?: boolean
  publicEventPages?: boolean
  name: string
  description?: string
  thumbnail: string
  favicon: string
  url: string
  defaultCurrency?: string
  customThumbnail?: string
  socials: {
    instagramLink?: string
    soundcloudLink?: string
    youtubeLink?: string
  }
  styles: {
    openCalls?: boolean
    comingSoon?: {
      bgColor: string
      hero: {
        desktop?: string
        mobile?: string
        style?: string
      }
      logo: {
        desktop?: string
        mobile?: string
        style?: string
      }
      werzLogoColor?: string
      title: string
      text: string
      button: string
      input: {
        base: string
        border?: string
        borderFocus?: string
        borderError?: string
        errorText?: string
      }
      error?: string
      footerText?: string
      skipButton?: string
      socHideLogo?: boolean
      modal: {
        container: string
        title: string
        text: string
        width?: string
        backdrop?: string
        otpInput?: string
        otpBorder?: string
        otpBorderFocus?: string
      }
    }
    global: {
      mobileOnly?: boolean
      inviteGate?: {
        mobileLayout?: "downloadFirst" | "joinFirst"
        continueOnMobileLabel?: string
      }
      counterColor?: string
      alternativeLogo?: {
        src: string
        styles: string
      }
      logo: {
        src: string
        styles: string
      }
      modalWindow: {
        container: string
        title: string
        subtitle: string
        input?: {
          container?: string
          input?: string
        }
        amountInput?: {
          container?: string
          input?: string
          currency?: string
          inputError?: {
            container?: string
            input?: string
            currency?: string
          }
          error?: string
        }
        button?: string
      }
      werzLogoColor?: string
      bgColor: string
      asideBg: string
      asideStyles: string
      contentBg: string
      contentBoxShadow: string
      nonMemberBg?: string
      nonMemberBgColor?: string
      nonMemberBgStyles?: string
      nonMemberBgContainerStyles?: string
      bgDesktop: string
      bgMobile: string
      mainFont: string
      // Surface classes for skeleton loading blocks, e.g. "bg-gray-400/40 rounded".
      // Defaults to a neutral translucent gray when omitted.
      skeleton?: string
      primaryButton: string
      customPrimaryButton?: CUSTOM_COMMUNITY_BUTTONS | string
      scrollArrow?: {
        background?: string
        color?: string
      }
    }
    navigation: {
      iconsColor: string
      sideBarSeparator: string
      separator: string
      item: string
      itemSelected: string
    }
    communityLanding: {
      titles: string
      emptyOrLoadingState: string
      container?: string
      announcements?: {
        container?: string
        media?: string
        customBg?: string
        lg: {
          title: string
          subtitle: string
        }
        sm: {
          title: string
          subtitle: string
        }
      }
      announcementsV2?: {
        sectionContainer?: string
        sectionTitle?: string
        scrollMenu?: {
          container?: string
          wrapper?: string
          item?: string
        }
        item: {
          container: string
          media: string
          mediaContainer: string
          placeholderMedia: string
          content: string
          title: string
          subtitle: string
        }
      }
      event?: {
        singleContainer?: string
        container?: string
        media?: string
        title: string
        subtitle: string
      }
      eventsV2?: {
        sectionContainer?: string
        sectionTitle?: string
        scrollMenu?: {
          container?: string
          wrapper?: string
          item?: string
        }
        item: {
          container: string
          media: string
          mediaContainer: string
          placeholderMedia: string
          content: string
          title: string
          subtitle?: string
          location: string
          date: string
        }
      }
      shop: {
        container?: string
        media?: string
        title: string
        text: string
        customShopImage?: string
        customShopImageStyle?: string
        sectionTitle?: string
      }
    }
    announcements?: {
      emptyOrLoadingState: string
      created: string
      container: string
      header: string
      title: string
      description: string
      media?: string
    }
    announcement?: {
      media?: string
      emptyOrLoadingState: string
      created: string
      container: string
      title: string
      description: string
      commentIconColor: string
      likeIconColor: string
      likeCount: string
      commentCount: string
    }
    events?: {
      media?: string
      sectionHeader: string
      separator: string
      container: string
      header: string
      title: string
      emptyOrLoadingState: string
      duration: string
      address: string
    }
    event?: {
      media?: string
      emptyOrLoadingState: string
      container: string
      blockContainer: string
      header: string
      sectionTitle: string
      sectionSubtitle: string
      text: string
      separator: string
      sectionContainer?: string
      map: {
        pin: string
        border: string
        pinColor: string
        strokeColor: string
      }
    }
    eventV2?: {
      container: string
      eventInfo: {
        container: string
        media: string
        title: string
        subtitle: string
        questions: string
        button?: string
      }
      about: {
        container: string
        header: string
        text: string
      }
      location: {
        container: string
        header: string
        text: string
        map: string
        mapPinColor: string
        mapStrokeColor: string
      }
      downloadWERZ: {
        container: string
        header: string
        text: string
      }
      tickets: {
        header: string
        outerContainer: string
        innerContainer: string
        accessCode?: {
          button: string
        }
        ticket: {
          container: string
          media?: string
          mediaContainer?: string
          name: string
          description: string
          price: string
          quantity: string
          status: string
          counterContainer: string
          plusMinusColor?: string
          button: string
          descriptionCutoff?: number
        }
      }
    }
    eventTickets?: {
      container: string
      separator: string
      event: {
        title: string
        subtitle: string
        media?: string
      }
      accessCode?: {
        container: string
        ticketsTitle: string
        text: string
      }
      ticket: {
        container?: string
        title: string
        description?: string
        media?: string
        text: string
        price: string
        status?: string
        counterContainer: string
        plusMinusColor?: string
        quantity: string
      }
    }
    forumPosts?: {
      container: string
      cardsContainer: string
      header: string
      createPostButton: string
      tags: {
        container: string
        tag: string
        selectedTag: string
      }
      forumPost: {
        container: string
        cardContainer: string
        actionButton: {
          container: string
          button: string
          clickedButton: string
          action: string
        }
        info: {
          authorAvatar: string
          authorName: string
          container: string
          createdAt: string
          dot: string
        }
        headline: string
        media: string
        content: string
        tags: {
          container: string
          status: string
          tag: string
        }
        engagements: {
          commentIconColor: string
          commentsCount: string
          container: string
          likeIconColor: string
          likesCount: string
        }
      }
      emptyOrLoadingState: string
    }
    forumPost?: {
      container: string
      cardContainer: string
      headline: string
      actionButton: {
        container: string
        button: string
        clickedButton: string
        action: string
      }
      info: {
        container: string
        authorAvatar: string
        authorName: string
        dot: string
        createdAt: string
      }
      mediaCarousel: {
        className: string
      }
      content: string
      tags: {
        container: string
        status: string
        tag: string
      }
      engagements: {
        commentIconColor: string
        commentsCount: string
        container: string
        likeIconColor: string
        likesCount: string
      }
      comments: {
        header: string
        createCommentButton: string
        repliesContainer: string
        container: string
        comment: {
          content: string
          info: {
            container: string
            authorAvatar: string
            dot: string
            authorName: string
            createdAt: string
          }
          mediaCarousel: {
            className: string
          }
          engagements: {
            container: string
            replyIconColor: string
            replyText: string
            likeIconColor: string
            likesCount: string
            actionButton: {
              container: string
              button: string
              clickedButton: string
              action: string
            }
          }
        }
        emptyOrLoadingState: string
      }
      loadingState: string
    }
    shop?: {
      container?: string
      sectionTitle?: string
      header?: string
      separator?: string
      emptyState?: string
    }
    shopV2?: {
      container: string
      header: string
      emptyState: string
      eventSection: {
        container: string
        header: string
        event: {
          container: string
          dateBox: string
          month?: string
          day?: string
          details: string
          name: string
          date: string
          location: string
        }
        tickets: {
          container: string
          ticket: {
            container: string
            media?: string
            mediaContainer?: string
            name: string
            description: string
            price: string
            quantity: string
            status: string
            counterContainer: string
            plusMinusColor?: string
            button: string
            descriptionCutoff?: number
          }
        }
      }
      membershipSection?: {
        container: string
        header: string
        products: {
          container: string
          product: {
            container: string
            media?: string
            mediaContainer?: string
            name: string
            description: string
            price: string
            quantity?: string
            status?: string
            counterContainer?: string
            plusMinusColor?: string
            button: string
            descriptionCutoff?: number
          }
        }
      }
      merchSection?: {
        container: string
        header: string
        products: {
          container: string
          product: {
            container: string
            innerContainer?: string
            media?: string
            mediaContainer?: string
            name: string
            description: string
            price: string
            quantity?: string
            status?: string
            counterContainer?: string
            plusMinusColor?: string
            button?: string
            descriptionCutoff?: number
          }
        }
      }
    }
    linktree?: {
      bgDesktop: string
      bgMobile: string
      bgColor?: string
      bgMedia?: string
      container: string
      communityInfo: {
        logo: string
        name: string
        location: string
        description: string
        socialMediaIconColor: string
        button: string
      }
      radioTracks?: {
        container: string
        header: string
        loadingState: string
        radioTrack: {
          container: string
          coverUrl: string
          duration: string
          liveType: string
          liveTypeCircle: string
          playIconColor: string
          playIconBackgroundColor?: string
          playIconBorderColor?: string
          start: string
          title: string
        }
        seeAllTracks: string
      }
      upcomingEvents: {
        seeAllEvents: string
        loadingState: string
        emptyState: {
          container: string
          title: string
          text: string
          button: string
        }
        header: string
        container: string
        collapsedEvent: {
          container: string
          duration: string
          name: string
          plusIconColor: string
          media: string
        }
        event: {
          container: string
          name: string
          startDate: string
          duration: string
          location: string
          button?: string
          product: {
            container: string
            price: string
            link: string
            status: string
            name: string
            button: string
          }
        }
      }
      news: {
        loadingState: string
        header: string
        container: string
        oneNews: {
          container: string
          name: string
          triangleIconColor: string
          created: string
          media: string
        }
        seeAllNews: string
      }
      otherLinks: {
        loadingState: string
        header: string
        container: string
        link: {
          container: string
          name: string
          triangleIconColor: string
          circleIcon: string
        }
      }
      footer: {
        WERZlogoColor: string
        text?: string
      }
    }
    shopProductV2?: {
      container: string
      media: string
      mediaContainer?: string
      title: string
      additionalDetails: string
      priceSection: string
      displayPrice: string
      shortTerms: string
      variantSelector?: {
        section?: string
        separator: string
        label: string
        sizeButton: string
        sizeButtonSelected: string
        sizeButtonOneSize: string
        colorSwatchContainer: string
        colorSwatch: string
        colorSwatchSelected: string
        validationMessage?: string
      }
      counter?: {
        container: string
        quantity: string
        plusMinusColor?: string
      }
      button: string
    }
  }
}
